import { ReferanceAsyncSelect } from './referance-async-select'

export function SelectReferanceCode({ name }) {
  return <ReferanceAsyncSelect name={name} labelCategory="YIKAMA TALİMATI" />
}
